import { useState } from 'react';
import { apiFetch } from '../../../../../utils/api';

export function CombinationGenerator({ familyId, featureId, featureName, features, onGenerated }) {
    const candidates = (features || []).filter(item => item.id !== featureId);
    const [selectedIds, setSelectedIds] = useState([]);
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');

    const toggle = (id) => {
        setSelectedIds(prev => prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]);
    };

    const generate = async () => {
        if (!familyId || selectedIds.length === 0) return;
        setBusy(true);
        setMessage('');
        try {
            const res = await apiFetch(`/api/products/${familyId}/visual-combinations`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    visualFeatureId: featureId,
                    visualFeatureName: featureName,
                    drivingFeatureIds: selectedIds
                })
            });
            if (!res.ok) {
                setMessage(await res.text());
                return;
            }
            const data = await res.json();
            setMessage(`Created ${data.createdValues || 0} galleries, reused ${data.reusedValues || 0}. Ruleset: ${data.ruleSetName}.`);
            onGenerated?.(data);
        } catch (err) {
            console.error(err);
            setMessage('Failed to generate combinations.');
        } finally {
            setBusy(false);
        }
    };

    if (!familyId) return null;

    return (
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '0.75rem', display: 'flex', flexDirection: 'column', gap: '0.45rem' }}>
            <label style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-secondary)' }}>Combination galleries</label>
            <p style={{ margin: 0, fontSize: '0.7rem', color: 'var(--text-secondary)' }}>
                Pick driving features such as Color and Rims. This creates one gallery value per combination and a mapping ruleset the carousel can follow.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', maxHeight: '120px', overflowY: 'auto' }}>
                {candidates.map(item => (
                    <label key={item.id} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.75rem' }}>
                        <input type="checkbox" checked={selectedIds.includes(item.id)} onChange={() => toggle(item.id)} />
                        {item.name}
                    </label>
                ))}
            </div>
            <button type="button" className="btn-primary" disabled={busy || selectedIds.length === 0} onClick={generate} style={{ fontSize: '0.75rem', padding: '0.35rem 0.7rem', alignSelf: 'flex-start' }}>
                {busy ? 'Generating...' : 'Generate combinations'}
            </button>
            {message && <span style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>{message}</span>}
        </div>
    );
}
